import React from 'react';
import ProgramItem from '../../../entities/programs/ui/ProgramItem';

// Програм одиниці, тому списком керує сторінка: вона фільтрує масив і
// передає сюди вже готовий результат разом із загальною кількістю.
const ProgramsList = ({ data, totalCount }) => {
    const shown = data?.items?.length || 0;
    const total = typeof totalCount === 'number' ? totalCount : shown;

    return (
        <div className='admin-list'>
            <div className="admin-list__header">
                <p className="admin-list__header-info">
                    {shown === total ? `${total} програм` : `Знайдено ${shown} з ${total}`}
                </p>
            </div>

            <div className="admin-list__content">
                <ul className="admin-list__content-titles team-grid">
                    <li>Назва</li>
                    <li>Вік</li>
                    <li>Видимість</li>
                    <li>Дія</li>
                </ul>
                <ul className="admin-list__content-items">
                    {data?.items?.length > 0 ? (
                        data.items.map((program) => (
                            <ProgramItem
                                key={program._id || program.id || program.slug}
                                program={program}
                            />
                        ))
                    ) : (
                        <li className="admin-list__empty">Нічого не знайдено</li>
                    )}
                </ul>
            </div>

        </div>
    );
};

export default ProgramsList;
